import React from "react";

import * as Styled from "./FooterLink.styled";

export const FooterLink: React.FC<
  React.ComponentPropsWithoutRef<"a">
> = props => {
  return <Styled.Link {...props} />;
};
